import {
  CommonControlsHierarchyResponse,
  FrameworkControl,
} from '../../types/dynamodb';
import { ListControlsResponse, NexusApiService } from '../nexusApiService';

/**
 * Backend-aligned UI client for NexusControlService APIs.
 */
export class NexusControlService {
  constructor(private readonly api: NexusApiService) {}

  async listControls(
    frameworkName: string,
    frameworkVersion: string,
    params?: { maxResults?: number; nextToken?: string; status?: string }
  ): Promise<ListControlsResponse> {
    return this.api.listControls(frameworkName, frameworkVersion, params);
  }

  async getControl(
    frameworkName: string,
    frameworkVersion: string,
    controlId: string
  ): Promise<FrameworkControl> {
    return this.api.getControl(frameworkName, frameworkVersion, controlId);
  }

  async getFrameworkControlsByKey(
    frameworkKey: string
  ): Promise<FrameworkControl[]> {
    return this.api.getFrameworkControlsByKey(frameworkKey);
  }

  async batchGetFrameworkControls(
    controls: Array<{ frameworkKey: string; controlKey: string }>
  ): Promise<Map<string, FrameworkControl>> {
    return this.api.batchGetFrameworkControls(controls);
  }

  async getCommonControlsWithHierarchy(): Promise<CommonControlsHierarchyResponse> {
    return this.api.getCommonControlsWithHierarchy();
  }
}

